import cn from 'utils/cn'
import { ReactNode } from 'react'
import BackNavLink from '../navigation/BackNavLink'

type CardPageWrapperProps = {
  pageClassName?: string
  cardClassName?: string
  wrapperClassName?: string
  backUrl?: string
  children: ReactNode
  company: 'motus' | 'everlance'
  dataTitle: string
}

const CardPageWrapper = ({
  pageClassName,
  cardClassName,
  wrapperClassName,
  backUrl,
  company,
  children,
  dataTitle
}: CardPageWrapperProps) => {
  const isMotus = company === 'motus'
  return (
    <div
      data-title={dataTitle}
      className={cn(
        'min-h-[calc(100svh-4.6rem)] flex justify-around items-center p-3',
        isMotus && 'bg-primary-1',
        pageClassName
      )}
    >
      <div className={cn('card bg-white mb-5 w-[500px]', cardClassName)}>
        {backUrl && (
          <BackNavLink
            shouldReplace
            overrideHistory
            to={backUrl}
            className="text-primary"
          />
        )}
        <div className={cn('my-20 px-14', wrapperClassName)}>{children}</div>
      </div>
    </div>
  )
}

export default CardPageWrapper
